function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export { canHaveRef } from '@deephaven/components';

/**
 * Dehydrate an existing panel to allow it to be serialized/saved.
 * Just takes what's in the panels `metadata` in the props and `panelState` in
 * the component state, assumes it's serializable, and saves it.
 * @param config The panel config to dehydrate
 * @returns The dehydrated PanelConfig
 */
export function dehydrate(config) {
  var props = config.props,
    componentState = config.componentState;
  var metadata = props.metadata;
  var _props$panelState = props.panelState,
    panelState = _props$panelState === void 0 ? null : _props$panelState;
  if (componentState) {
    panelState = componentState.panelState;
  }
  var newProps = {};
  if (metadata != null) {
    newProps.metadata = metadata;
  }
  if (panelState != null) {
    newProps.panelState = panelState;
  }
  return _objectSpread(_objectSpread({}, config), {}, {
    componentState: null,
    props: newProps,
    type: 'react-component'
  });
}

/**
 * Default hydration function. Just applies the dashboard ID. When used with dehydrate above,
 * the panels state will be stored in `panelState` prop.
 * @param props Panel props to hydrate
 * @param localDashboardId The local dashboard ID to hydrate the panel with
 * @returns The hydrated panel props
 */
export function hydrate(props, localDashboardId) {
  return _objectSpread(_objectSpread({}, props), {}, {
    localDashboardId
  });
}
export default {
  dehydrate,
  hydrate
};
//# sourceMappingURL=DashboardUtils.js.map